import { Lightbulb, Info } from "lucide-react";

export interface QuickAnswerBoxProps {
  question?: string;
  answer: string;
  sourceText?: string;
}

export function QuickAnswerBox({ question, answer, sourceText = "Corner Gayrimenkul Adana Saha Verileri" }: QuickAnswerBoxProps) {
  return (
    <div className="bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-transparent border-l-4 border-amber-500 p-5 rounded-r-2xl shadow-xs my-6 space-y-2">
      <div className="flex items-center gap-2 text-amber-600 font-extrabold text-xs uppercase tracking-wider">
        <Lightbulb className="h-4 w-4" />
        <span>Kısa Cevap</span>
        {question && <span className="text-muted-foreground font-normal normal-case ml-1">— {question}</span>}
      </div>
      <p className="text-foreground font-semibold text-base sm:text-lg leading-relaxed">
        {answer}
      </p>
      <div className="text-xs text-muted-foreground flex items-center gap-1 pt-1 border-t border-amber-500/20">
        <Info className="h-3 w-3 text-amber-500" />
        <span>Kaynak: {sourceText}</span>
      </div>
    </div>
  );
}
